export default __webpack_public_path__ + "static/media/avatar3.e504f245.jpg";